import { useQuery } from "@tanstack/react-query";
import { NOTIFICATIONS_PERSONAL_KEY, NOTIFICATIONS_COUNT_QUERY_KEY } from "Data/keys/QueryKeys";
import { NotificationApiV2 } from "Data/Notification.api.v2";

export const useQueryCountNewNotificationsPersonal = () => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [NOTIFICATIONS_COUNT_QUERY_KEY, NOTIFICATIONS_PERSONAL_KEY],
    staleTime: 60 * 5 * 1000, // 5 minutes
    queryFn: async () => {
      const { data } = await NotificationApiV2.countNewNotifications({
        personalOnly: true,
      });
      return data.data.count;
    },
  });

  return {
    data: data ?? 0,
    refetch,
    isLoading,
    isFetching,
    error,
  }
};
